import { put, all, takeLatest, select } from "redux-saga/effects";
import {
  REQNotificationDetail,
  RESNotificationDetail,
  SAVExNotification,
  SAVEDxNotification,
  PREVIEWxAudience,
  RESPreviewAudience,
  FailNotificationDetail
} from "./actions";
import * as actions from "../../Authentication/redux/actions";
import { NOTIFICATION_ADMIN_URL, authHeaders, readError } from "../../NotificationList/api";

function* adminSession() {
  const accessToken = yield select(state => state.auth.accessToken);
  const tGUID = yield select(state => state.auth.GUID);
  return authHeaders(accessToken, tGUID);
}

/* GET /api/v1/admin/notifications/:id */
function* fetchNotificationDetailWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}/${payload.id}`, {
      method: "GET",
      headers
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationDetail({ message }));
      return;
    }

    const response = yield request.json();
    yield put(RESNotificationDetail(response));
  } catch (error) {
    yield put(FailNotificationDetail({ message: error.message }));
  }
}

/* POST (create) or PUT (edit) /api/v1/admin/notifications */
function* saveNotificationWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const isEdit = Boolean(payload.id);
    const request = yield fetch(isEdit ? `${NOTIFICATION_ADMIN_URL}/${payload.id}` : NOTIFICATION_ADMIN_URL, {
      method: isEdit ? "PUT" : "POST",
      headers,
      body: JSON.stringify(payload.body)
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      const message = yield readError(request);
      yield put(FailNotificationDetail({ message }));
      return;
    }

    const response = yield request.json();
    yield put(SAVEDxNotification(response));
  } catch (error) {
    yield put(FailNotificationDetail({ message: error.message }));
  }
}

/* POST /api/v1/admin/notifications/preview-audience — how many customers the scope reaches */
function* previewAudienceWorker({ payload }) {
  try {
    const headers = yield adminSession();
    const request = yield fetch(`${NOTIFICATION_ADMIN_URL}/preview-audience`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload)
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      // The estimate is a convenience; a failure must not block the form.
      return;
    }

    const response = yield request.json();
    yield put(RESPreviewAudience(response));
  } catch (error) {
    // Same: the form stays usable without an estimate.
  }
}

export function* notificationDetailSaga() {
  yield all([
    takeLatest(REQNotificationDetail, fetchNotificationDetailWorker),
    takeLatest(SAVExNotification, saveNotificationWorker),
    takeLatest(PREVIEWxAudience, previewAudienceWorker)
  ]);
}
